import React, { useEffect, useState, useReducer } from 'react'
import { ListView, Checkbox, List } from 'antd-mobile'
import intl from 'react-intl-universal'
import './IndexList.css'
import MyModal from '../MyModal/MyModal'

const CheckboxItem = Checkbox.CheckboxItem

export default function IndexList (props) {
  const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID]
  const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID]
  const [datas, setDatas] = useState(props.dataSource.slice(0) || []) // 数据源
  const [dataSource, setDataSource] = useState(new ListView.DataSource({
    getRowData,
    getSectionHeaderData: getSectionData,
    rowHasChanged: (row1, row2) => true,
    sectionHeaderHasChanged: (s1, s2) => s1 !== s2
  }))

  const [selectedAdvicesArray, dispatchTemp] = useReducer(reducer, []) // 被选中的饮食医嘱（非最终结果）
  // const [result, dispatchResult] = useReducer(reducer, []) // 最终返回的结果
  const [defaultSelectedAdvicesArray, dispatchDefaultSelectedAdvicesArray] = useReducer(reducer, []) // 默认选中的饮食医嘱对象

  const [checkedArray, dispatchCheckedArray] = useReducer(reducer, props.defaultValue ? props.defaultValue.slice(0) : []) // 选中的饮食医嘱id
  const [defaultCheckedArray, dispatchDefaultCheckedArray] = useReducer(reducer, props.defaultValue ? props.defaultValue.slice(0) : []) // 第一次点开组件时默认选中的数据源

  const [fixItem, dispatch2] = useReducer(reducer, []) // 默认置顶的元素
  const fixIDs = ['9dbe725cf3084de9b5757a2370d56994'] // 默认指定元素的value
  const [showListModal, setShowListModal] = useState(false)
  const [listModalInfo, setListModalInfo] = useState('') // 提示信息弹窗的提示文本内容

  useEffect(() => {
    dispatchCheckedArray({
      type: 'set',
      payload: props.defaultValue.slice(0)
    })
    dispatchDefaultCheckedArray({
      type: 'set',
      payload: props.defaultValue.slice(0)
    })
  }, [props.defaultValue])

  useEffect(() => {
    setDatas(props.dataSource.slice(0) || [])
  }, [props.dataSource])

  function reducer (state, action) {
    let nextState = state.slice(0)
    if (action.type === 'push') {
      if (!nextState.includes(action.payload)) {
        nextState.push(action.payload)
      } else {
        nextState.splice(nextState.indexOf(action.payload), 1)
      }
    } else if (action.type === 'pushObj') {
      let exist = false // 对象是否存在
      let index = -1 // 对象如果存在，那在数组的第几个
      nextState.some((item, i) => {
        if (item.value === action.payload.value) {
          exist = true
          index = i
          return true
        } else {
          return false
        }
      })
      if (!exist) {
        nextState.push(action.payload)
      } else {
        nextState.splice(index, 1)
      }
    } else if (action.type === 'set') {
      nextState = [...action.payload]
    } else if (action.type === 'clearArray') {
      nextState.splice(0, nextState.length)
    }
    return nextState
  }

  /**
   * 设置默认选中的饮食医嘱
   */
  useEffect(() => {
    if (datas.length > 0 && defaultCheckedArray.length > 0) {
      const selectedTemp = []
      datas.map((item) => {
        defaultCheckedArray.map((jj) => {
          if (item.value === jj) {
            const tempObj = {}
            tempObj.value = item.value
            tempObj.label = item.label
            selectedTemp.push(tempObj)
          }
        })
      })
      dispatchTemp({
        type: 'set',
        payload: selectedTemp
      })
      dispatchDefaultSelectedAdvicesArray({
        type: 'set',
        payload: selectedTemp
      })
    } else {
      dispatchTemp({
        type: 'set',
        payload: []
      })
      dispatchDefaultSelectedAdvicesArray({
        type: 'set',
        payload: []
      })
    }
  }, [datas, defaultCheckedArray.join(',')])

  /**
   * 设置数据源
   */
  useEffect(() => {
    const tempDatas = [...datas]
    tempDatas.sort(function (a, b) {
      return a.spell.localeCompare(b.spell)
    })
    var transData = {}
    tempDatas.forEach(function (item) {
      if (fixIDs.includes(item.value)) {
        dispatch2({
          type: 'push',
          payload: item
        })
      } else {
        var qf = item.spell[0].toUpperCase()
        transData[qf] = transData[qf] || []
        transData[qf].push(item)
      }
    })
    // setTimeout(() => {
    setDataSource(genData(dataSource, transData))
    // }, 100)
  }, [props.visible])

  function genData (ds, foodAdviceData) {
    const dataBlob = {}
    const sectionIDs = []
    const rowIDs = []
    Object.keys(foodAdviceData).forEach((item, index) => {
      sectionIDs.push(item)
      dataBlob[item] = item
      rowIDs[index] = []

      foodAdviceData[item].forEach((jj) => {
        rowIDs[index].push(jj.value)
        dataBlob[jj.value] = jj.label
      })
    })
    return ds.cloneWithRowsAndSections(dataBlob, sectionIDs, rowIDs)
  }

  function getSelectedAdvices (adviceObj) {
    if (JSON.stringify(adviceObj) !== '{}') {
      dispatchTemp({
        type: 'pushObj',
        payload: adviceObj
      })
      dispatchCheckedArray({
        type: 'push',
        payload: adviceObj.value
      })
    } else {
      dispatchTemp({
        type: 'clearArray'
      })
      dispatchCheckedArray({
        type: 'clearArray'
      })
    }
    const tempDatas = [...datas]
    tempDatas.sort(function (a, b) {
      return a.spell.localeCompare(b.spell)
    })
    var transData = {}
    tempDatas.forEach(function (item) {
      var qf = item.spell[0].toUpperCase()
      transData[qf] = transData[qf] || []
      transData[qf].push(item)
    })
    setDataSource(genData(dataSource, transData))
  }

  function getResult () {
    dispatchDefaultSelectedAdvicesArray({
      type: 'set',
      payload: selectedAdvicesArray.slice(0)
    })
    dispatchDefaultCheckedArray({
      type: 'set',
      payload: checkedArray
    })
    // dispatchResult({
    //   type: 'set',
    //   payload: selectedAdvicesArray
    // })
    props.handleOnOkClick(selectedAdvicesArray)
  }

  function handleOnCancel () {
    dispatchTemp({
      type: 'set',
      payload: defaultSelectedAdvicesArray
    })
    // dispatchResult({
    //   type: 'set',
    //   payload: defaultSelectedAdvicesArray
    // })
    dispatchCheckedArray({
      type: 'set',
      payload: defaultCheckedArray
    })
    props.handleOnCancelClick(defaultSelectedAdvicesArray)
  }

  /**
   * 处理点击清空事件
   */
  function handleOnClear () {
    setShowListModal(true)
    setListModalInfo(intl.get('SureToClearDietOrders'))
  }

  return (
    <div
      style={{
        display: !props.visible ? 'none' : 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 9,
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
      }}
    >
      <div
        style={{
          width: '80%',
          maxHeight: '470px',
          minHeight: '430px',
          marginTop: '50px',
          marginRight: 'auto',
          marginLeft: 'auto',
          overflowY: 'scroll',
          WebkitOverflowScrolling: 'touch',
          zIndex: 10,
          backgroundColor: 'white',
          borderRadius: '10px'
        }}>
        <div
          style={{
            fontSize: '0.9rem',
            fontWeight: 'bolder',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '10px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {intl.get('ChooseFoodAdvice')}
        </div>
        {selectedAdvicesArray.length > 0 && <div
          style={{
            fontSize: '0.9rem',
            fontWeight: 'bolder',
            maxHeight: '40px',
            minHeight: '20px',
            paddingLeft: '20px',
            paddingRight: '10px',
            display: 'flex'

          }}
        >
          <div style={{ flex: 8, overflowY: 'scroll', lineHeight: '16px' }}>
            {selectedAdvicesArray.map((advice) => {
              return (<span
                key={advice.value}
                style={{
                  backgroundColor: 'rgb(213, 213, 241)',
                  borderRadius: '8px',
                  paddingLeft: '4px',
                  paddingRight: '4px',
                  paddingTop: '1px',
                  paddingBottom: '0px',
                  // lineHeight: '13px',
                  marginRight: '4px',
                  fontSize: '0.8rem',
                  fontWeight: 'lighter',
                  verticalAlign: 'middle',
                  display: 'inline-block',
                  marginTop: '1px',
                  marginBottom: '1px'
                }}
                onClick={() => {
                  getSelectedAdvices(advice)
                }}
              >{advice.label}</span>)
            })}
          </div>
          <div onClick={() => handleOnClear()} style={{ flex: 2, color: '#A99FCB', fontSize: '0.9rem', verticalAlign: 'middle' }}>
            {intl.get('Empty')}
          </div>
        </div>}

        <ListView.IndexedList
          className={'FoodAdviceList'}
          dataSource={dataSource}
          style={{ width: '92%', height: '350px' }}
          renderSectionWrapper={sectionID => {
            return (
              <div
                key={`s_${sectionID}_c`}
                style={{ zIndex: 14 }}
              />
            )
          }}
          renderSectionHeader={sectionData => {
            return (
              <div
                style={{
                  fontSize: '1rem',
                  fontWeight: 'lighter'
                }}
              >
                {sectionData}
              </div>
            )
          }}
          renderRow={(rowData, sectionID, rowID, highlightRow) =>
            <CheckboxItem
              key={sectionID}
              id={sectionID}
              onChange={() => {
                const tempObj = {}
                tempObj.value = rowID
                tempObj.label = rowData
                getSelectedAdvices(tempObj)
              }}
              value={rowID}
              checked={checkedArray.includes(rowID)}
            >
              <div style={{ fontSize: '0.9rem' }}>{rowData}</div>
            </CheckboxItem>
          }
          renderHeader={() => {
            if (fixItem.length > 0) {
              return (
                <List>
                  {fixItem.map((item) => (
                    <CheckboxItem
                      key={item.value}
                      checked={checkedArray.includes(item.value)}
                      onChange={() => {
                        getSelectedAdvices({
                          value: item.value,
                          label: item.label
                        })
                      }}
                    >
                      <div style={{ fontSize: '0.9rem' }}>{item.label}</div>
                    </CheckboxItem>
                  )
                  )}
                </List>
              )
            }
          }}
          quickSearchBarStyle={{
            top: '50px',
            color: '#A99FCB',
            touchAction: 'none',
            marginRight: '10%'
          }}
          delayTime={100}
          delayActivityIndicator={<div style={{ padding: 25, textAlign: 'center' }}>
            {intl.get('Waiting')}
          </div>}
        />
        <div
          style={{
            width: '100%',
            height: '40px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              flex: 1,
              height: '35px',
              fontSize: '0.9rem',
              fontWeight: 'bolder',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRight: '1px solid #9F9F9F',
              borderRightwidht: '10px'
            }}
            onClick={() => handleOnCancel()}
          >
            {intl.get('Cancel')}
          </div>
          <div
            style={{
              flex: 1,
              height: '35px',
              fontSize: '0.9rem',
              fontWeight: 'bolder',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            onClick={() => getResult()}
          >
            {intl.get('OK')}
          </div>
        </div>
      </div>
      <MyModal
        visible={showListModal}
        info={listModalInfo}
        onCancelClick={() => {
          setShowListModal(false)
        }}
        onOkClick={() => {
          setShowListModal(false)
          getSelectedAdvices({})
        }}
      />
    </div>
  )
}
